module.exports = __webpack_public_path__ + "img/camera.5b01e382.svg";